module.exports = __webpack_public_path__ + "static/Karen-Hincapie-4b5ac418659be72959d2cec99b12b63f.png";